import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import GlobalProvider from './context/GlobalProvider';
import './index.css';
import { FileProvider } from './providers/FileProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <GlobalProvider>
      <FileProvider>
        <App />
      </FileProvider>
    </GlobalProvider>
  </React.StrictMode>
);
